var _ref2, _ref3;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgEmoji = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 17.164,
      height: 17.164,
      viewBox: "0 0 17.164 17.164",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("defs", null,
    /*#__PURE__*/
    React.createElement("clipPath", {
      id: "clip-path"
    },
    /*#__PURE__*/
    React.createElement("rect", {
      id: "Rectangle_106730",
      "data-name": "Rectangle 106730",
      width: 17.164,
      height: 17.164
    })))), _ref3 || (_ref3 =
    /*#__PURE__*/
    React.createElement("g", {
      id: "Group_20233",
      "data-name": "Group 20233",
      clipPath: "url(#clip-path)"
    },
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_24978",
      "data-name": "Path 24978",
      d: "M8.582,0a8.582,8.582,0,1,0,8.582,8.582A8.582,8.582,0,0,0,8.582,0M3.457,7.514a1.908,1.908,0,0,1,3.815,0,.657.657,0,0,1-.656.656h0a.658.658,0,0,1-.656-.656.6.6,0,0,0-1.192,0,.656.656,0,0,1-1.312,0m9.377,3.7c-.011.012-.022.023-.033.033a5.965,5.965,0,0,1-4.2,1.745H8.567a5.961,5.961,0,0,1-4.2-1.748.656.656,0,0,1,.923-.93,4.659,4.659,0,0,0,6.583,0h0a.656.656,0,1,1,.959.9m.218-3.051h0a.658.658,0,0,1-.656-.656.6.6,0,1,0-1.192,0,.656.656,0,0,1-1.312,0,1.908,1.908,0,0,1,3.815,0,.657.657,0,0,1-.656.656",
      transform: "translate(0 0.001)"
    }))))
  );
};

const ForwardRef =
/*#__PURE__*/
React.forwardRef((props, ref) =>
/*#__PURE__*/
React.createElement(SvgEmoji, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Emoji.2dd9a26c.svg";
export { ForwardRef as ReactComponent };